import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import host from "../config";
import { display } from "@mui/system";

const Bookingdetail = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // const { date, locationId, roomId, access_token } = location.state || {};
  const { date, locationId, roomId, access_token, clickType } = location.state || {};


  const [loading, setLoading] = useState(true);
  const [bookings, setBookings] = useState([]);
  const [error, setError] = useState(null);
  const [roomName, setRoomName] = useState("");
const [locationName, setLocationName] = useState("");

useEffect(() => {
  const styleTag = document.createElement("style");
  styleTag.innerHTML = `
    footer {
      display: none !important;
    }
  `;
  document.head.appendChild(styleTag);

  return () => {
    document.head.removeChild(styleTag);
  };
}, []);



  // Convert UTC date -> Local YYYY-MM-DD
  const toLocalDate = (d) => {
    const dt = new Date(d);
    dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
    return dt.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (!date || !locationId) {
      setError("Missing date or location.");
      setLoading(false);
      return;
    }

    if (!access_token) {
      setError("Access token missing. Please login.");
      setLoading(false);
      return;
    }

    const fetchBookings = async () => {
      setLoading(true);
      setError(null);

      // const url = `${host}/getBookingDetailsByDate?date=${toLocalDate(
      //   date
      // )}&location=${locationId}&room_id=${roomId}`;
      let url;

if (clickType === "not available") {
  url = `${host}/getBlockingDetailsByDate?date=${toLocalDate(date)}&location=${locationId}&room_id=${roomId}`;
} else {
  url = `${host}/getBookingDetailsByDate?date=${toLocalDate(date)}&location=${locationId}&room_id=${roomId}`;
}

console.log("Calling API:", url);


      console.log("API:", url);

      try {
        const resp = await fetch(url, {
          method: "GET",
          headers: { Authorization: access_token },
        });

        if (resp.status === 403) {
          setError("This page only for authorized users.");
          setLoading(false);
          return;
        }

        if (!resp.ok) {
          setError("Failed to fetch booking details.");
          setLoading(false);
          return;
        }

        const json = await resp.json();

        if (!json.data || !Array.isArray(json.data)) {
          setBookings([]);
          setLoading(false);
          return;
        }

        const rows = json.data;

        // -------- REMOVE DUPLICATES --------
        const unique = {};
        rows.forEach((item) => {
          const day = toLocalDate(item.date);
          const key = `${item.booking_group_id}_${day}`;

          if (!unique[key]) {
            // unique[key] = {
            //   orderId: item.booking_group_id, // You only have group id
            //   customerName: item.customer_name,
            //   contactNo: item.contact_no,
            //   email: item.email_id || "",
            //   purpose: item.purpose,
            //   roomName: item.room_name,
            //   roomId: item.room_id,
            //   locationId: item.location_id,
            //   status: item.is_blocked ? "Blocked" : "Booked",
            //   date: day,
            // };
          unique[key] = {
  orderId: item.booking_group_id,
  customerName: item.customer_name,
  contactNo: item.contact_no,
  email: item.email_id || "",
  purpose: item.purpose,
  roomName: item.room_name,
  roomId: item.room_id,
  locationId: item.location_id,
  locationName: item.location_name || "",   // Add this
  status: item.is_blocked ? "Blocked" : "Booked",
  date: day,
};

        
        }
        });

        const uniqueRows = Object.values(unique);
        if (uniqueRows.length > 0) {
  setRoomName(uniqueRows[0].roomName || "");
  setLocationName(uniqueRows[0].locationName || "");
}


        // -------- FILTER EXACT ROOM + LOCATION + DATE --------
        const finalList = uniqueRows.filter(
          (x) =>
            String(x.locationId) === String(locationId) &&
            String(x.roomId) === String(roomId) &&
            x.date === toLocalDate(date)
        );

        setBookings(finalList);
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Error loading booking details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, [date, locationId, roomId, access_token]);

  const handleBack = () => navigate(-1);

// 

//     <div style={{ padding: 16, maxWidth: 900, margin: "auto" }}>
//       <h2>Booking Details</h2>

//       <div style={{ marginBottom: 12 }}>
//         <strong>Date:</strong> {toLocalDate(date)} &nbsp;|&nbsp;
//         <strong>Location:</strong> {locationId} &nbsp;|&nbsp;
//         <strong>Room:</strong> {roomId}
//       </div>

//       <button onClick={handleBack} style={{ marginBottom: 12 }}>
//         ← Back
//       </button>

//       {loading && <p>Loading…</p>}
//       {error && <p style={{ color: "red" }}>{error}</p>}

//       {!loading && !error && bookings.length === 0 && (
//         <p>No bookings found for this date.</p>
//       )}

//       {!loading && bookings.length > 0 && (
//         <table style={{ width: "100%", borderCollapse: "collapse" }}>
//           <thead>
//             <tr>
//               <th style={thStyle}>S.No</th>
//               <th style={thStyle}>Booking ID</th>
//               <th style={thStyle}>Customer</th>
//               <th style={thStyle}>Contact</th>
//               <th style={thStyle}>Purpose</th>
//               <th style={thStyle}>Room</th>
//               <th style={thStyle}>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {bookings.map((b, i) => (
//               <tr key={i}>
//                 <td style={tdStyle}>{i + 1}</td>
//                 <td style={tdStyle}>{b.orderId}</td>
//                 <td style={tdStyle}>{b.customerName}</td>
//                 <td style={tdStyle}>{b.contactNo}</td>
//                 <td style={tdStyle}>{b.purpose}</td>
//                 <td style={tdStyle}>{b.roomName}</td>
//                 <td style={tdStyle}>{b.status}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
return (
  <div style={pageContainer}>
    <h2 style={titleStyle}>📅 Booking Details</h2>

    {/* <div style={infoContainer}>
      <span><strong>Date:</strong> {toLocalDate(date)}</span>
      <span>|</span>
      <span><strong>Location:</strong> {locationId}</span>
      <span>|</span>
      <span><strong>Room:</strong> {roomId}</span>
    </div> */}

    <div style={infoContainer}>
  <span><strong>Date:</strong> {toLocalDate(date)}</span>
  <span>|</span>
  <span><strong>Location:</strong> {locationName || "—"}</span>
  <span>|</span>
  <span><strong>Room:</strong> {roomName || "—"}</span>
</div>


    <button onClick={handleBack} style={backBtn}>
      ← Back
    </button>

    {loading && <p style={loadingStyle}>Loading…</p>}
    {error && <p style={errorStyle}>{error}</p>}

    {!loading && !error && bookings.length === 0 && (
      <p style={noDataStyle}>No bookings found for this date.</p>
    )}

    {!loading && bookings.length > 0 && (
      <div style={tableWrapper}>
        <table style={tableStyle}>
          <thead>
            <tr style={theadRow}>
              <th style={thStyle}>S.No</th>
              <th style={thStyle}>Booking ID</th>
              <th style={thStyle}>Customer</th>
              <th style={thStyle}>Contact</th>
              <th style={thStyle}>Purpose</th>
              <th style={thStyle}>Room</th>
              <th style={thStyle}>Status</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((b, i) => (
              <tr key={i} style={tbodyRow}>
                <td style={tdStyle}>{i + 1}</td>
                <td style={tdStyle}>{b.orderId}</td>
                <td style={tdStyle}>{b.customerName}</td>
                <td style={tdStyle}>{b.contactNo}</td>
                <td style={tdStyle}>{b.purpose}</td>
                <td style={tdStyle}>{b.roomName}</td>
                <td style={{ ...tdStyle, fontWeight: "600", color: b.status === "Blocked" ? "#d9534f" : "#28a745" }}>
                  {b.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

};

const pageContainer = {
  maxWidth: "1000px",
  margin: "auto",
  padding: "20px",
  fontFamily: "Segoe UI, sans-serif",
};

const titleStyle = {
  fontSize: "28px",
  marginBottom: "10px",
  fontWeight: "700",
  textAlign: "center",
};

const infoContainer = {
  background: "#f3f6f9",
  padding: "10px 15px",
  borderRadius: "8px",
  marginBottom: "15px",
  display: "flex",
  gap: "10px",
  justifyContent: "center",
  fontSize: "16px",
};

const backBtn = {
  background: "#444",
  border: "none",
  padding: "8px 16px",
  color: "white",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "15px",
};

const loadingStyle = {
  textAlign: "center",
};

const errorStyle = {
  color: "red",
  fontWeight: "600",
  textAlign: "center",
};

const noDataStyle = {
  textAlign: "center",
  fontSize: "18px",
  marginTop: "20px",
  color: "#777",
};

const tableWrapper = {
  borderRadius: "10px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
};

const footerStyle = {
  display:"none"
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: "15px",
};

const theadRow = {
  background: "linear-gradient(90deg, #4d5dfb, #6f4bff)",
  color: "white",
};

const tbodyRow = {
  background: "white",
  transition: "0.3s",
};

tbodyRow["&:hover"] = {
  background: "#f1f5ff",
};

const thStyle = {
  padding: "12px 10px",
  textAlign: "left",
  fontWeight: "600",
};

const tdStyle = {
  padding: "12px 10px",
  borderBottom: "1px solid #eef1f5",
};


export default Bookingdetail;
